<mat-card >
  <mat-card-content>
      <mat-toolbar color="primary">Instagram</mat-toolbar>
      <ng-template #attente>
          <br>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <div *ngIf="enregistrementTerminer;else attente"></div>
      <br>
      <mat-form-field style="width: 400px;" >
        <input matInput name="FileLien" #FileLien="ngModel" [(ngModel)]="File_Lien" placeholder="Url">
      </mat-form-field>
      <img  (click)="importer()" style="width: 70px;" [src]="File_Content">
      <input id="input_file" type="file" value="importer" style="display:none;" (change)="onChangeImagefile($event)">
      <button [disabled]="!enregistrementTerminer" (click)="ajouter()" mat-raised-button class="colorGreen">Ajouter</button>
      <button [disabled]="!enregistrementTerminer" (click)="modifier()" mat-raised-button color="primary">modifier</button>
      <button [disabled]="!enregistrementTerminer" (click)="supprimer()" mat-raised-button class="colorReed">Supprimer</button>
      <div class="display-flex">
        <img style="width: 100px;cursor: pointer;" (click)="selectImage(img)" [src]="img.File_Content" *ngFor="let img of listeImages">
      </div>
    </mat-card-content>
  </mat-card>
